import React from 'react'
import { Link } from 'react-router-dom';

function PortfolioTwo() {
  return (
    <div>
      {/* Start Portfolio area  */}
      <div className="portfolio-area portfolio-style-two">
        <div className="container">
          <div className="row mb--30">
            <div className="col-lg-5 col-md-6">
              <div className="inner">
                <div className="section-head section-head-one-side text-align-left">
                  <div className="section-sub-title color-secondary">
                    {/* <span className="subtitle">OUR PORTFOLIO</span> */}
                  </div>
                  <h2 style={{marginTop:"70px"}} className="title split-collab">
                    Explore some of our finest<br /> client success stories{" "}
                  </h2>
                </div>
                <p style={{textAlign:"justify"}} className="description">
                  AQ Audit has delivered exceptional financial consulting, audit, and compliance services across various industries. From startups to enterprises, we’ve helped streamline operations, ensure regulatory alignment, and drive informed decisions. Our work reflects precision, trust, and long-term value creation for every client.
                </p>
                <Link
                  to={'/Project'}
                  className="tmp-btn btn-with-icon btn-secondary"
                >
                  Our All Works
                  <i className="fa-light fa-arrow-right" />
                </Link>
              </div>
            </div>
            <div
              className="col-lg-7 col-md-6 mt_md--80 mt_sm--50 wow fadeInUp"
              data-wow-duration=".8s"
              data-wow-delay=".1s"
            >
              <div
                className=""
                data-tmp-cursor="lg"
                data-tmp-cursor-text="View Details"
              >
                <Link to={'/ProjectDetails'} className="thumbnail">
                  <img
                    src="assets/images/portfolio/port.jpg"
                    alt="corporate business"
                  />
                </Link>
                <div className="portfolio-tag">
                  <div className="content">
                    <Link to={'/ProjectDetails'}>
                      <h3 className="name">Janet Phillips</h3>
                    </Link>
                    <div className="designation">Software Developer</div>
                  </div>
                  <Link
                    to={'/ProjectDetails'}
                    className="icon angle-roted border-none bg-color-white"
                  >
                    <i className="fa-solid fa-arrow-right" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Portfolio area  */}
    </div>
  )
}

export default PortfolioTwo
